export default "__VITE_ASSET__BNUm9F24__"